import allStarPurse from "../../image/purses/allstar2.webp";

import Collection from "./Collection";

const PursesCollection = () => {
  const title = "PURSES";

  const items = [
    {
      title: "All Star Purse",
      imageUrl: allStarPurse,
      projectUrl: "/AllStarPurse",
    },
  ];

  return (
    <Collection
      items={items}
      title={title}
      variant="boutique"
      eyebrow="Wearable Art"
      description="Functional art accessories designed with expressive detail and bold personality."
      pageClassName="collection-page--purses"
      showFooter
    />
  );
};

export default PursesCollection;
